import { createContext } from 'react'

import { ISchema } from 'src/types/interfaces/ISchema'

export const SchemaContext = createContext<ISchema>({} as ISchema)
